__turbopack_context__.v({
  "divider": "navigation-section-module__sUgSLq__divider",
  "group": "navigation-section-module__sUgSLq__group",
  "toggleButton": "navigation-section-module__sUgSLq__toggleButton",
  "toggleButtonCollapsed": "navigation-section-module__sUgSLq__toggleButtonCollapsed",
  "toggleLabel": "navigation-section-module__sUgSLq__toggleLabel",
});
